import { Box, Flex, FlexProps, Icon, Link, Progress, Spinner, Text } from "@chakra-ui/react";
import { useObservableState } from "applesauce-react/hooks";
import { PublishResponse } from "applesauce-relay";
import { Link as RouterLink } from "react-router-dom";

import { EmbedEventCard } from "../../../components/embed-event/card";
import { PublishLogEntry } from "../../../providers/global/publish-provider";
import { RelayPaidTag } from "../../relays/components/relay-card";
import { CheckIcon, ErrorIcon } from "../../../components/icons";

function PublishResultRow({ response }: { response: PublishResponse }) {
  return (
    <Flex gap="2" alignItems="center" px="2" py="1">
      <Icon as={response.ok ? CheckIcon : ErrorIcon} color={response.ok ? "green.500" : "orange.500"} boxSize={4} />
      <Link as={RouterLink} to={`/relays/${encodeURIComponent(response.from)}`} fontSize="sm">
        {response.from}
      </Link>
      <RelayPaidTag url={response.from} />
      {response.message && (
        <Text fontSize="xs" color="GrayText" isTruncated>
          {response.message}
        </Text>
      )}
    </Flex>
  );
}

export function PublishLogEntryDetails({ entry }: { entry: PublishLogEntry } & Omit<FlexProps, "children">) {
  const relayStatus = useObservableState(entry.relayStatus$) ?? {};
  const done = Object.keys(relayStatus).length;
  const total = entry.relays.length;

  return (
    <Flex direction="column" gap="2">
      <EmbedEventCard event={entry.event} />
      <Progress value={(done / total) * 100} size="xs" borderRadius="full" colorScheme="green" />
      {Object.entries(relayStatus).map(([url, response]) =>
        response ? (
          <PublishResultRow key={url} response={response} />
        ) : (
          <Flex key={url} gap="2" alignItems="center" px="2" py="1">
            <Spinner size="xs" />
            <Link as={RouterLink} to={`/relays/${encodeURIComponent(url)}`} fontSize="sm">
              {url}
            </Link>
            <RelayPaidTag url={url} />
          </Flex>
        ),
      )}
    </Flex>
  );
}
